export default __webpack_public_path__ + "static/media/icon_artesprontas_gray.40b79c6b.svg";